import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Map, Navigation, Beer } from "lucide-react";
import { useAuth } from "@/App";
import { useEffect } from "react";

const LOGO_URL = "https://res.cloudinary.com/dmivaa0e0/image/upload/v1772834626/branding/logo_badge.png";
const HERO_IMAGE = "https://res.cloudinary.com/dmivaa0e0/image/upload/v1772834427/landing/hero_motorcycle.jpg";

const Landing = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && user) {
      navigate("/dashboard");
    }
  }, [user, loading, navigate]);

  return (
    <div className="mobile-container asphalt-texture h-[100dvh] flex flex-col overflow-hidden">
      {/* Hero Section - Compact */}
      <div className="relative flex-1 min-h-0 overflow-hidden">
        <img
          src={HERO_IMAGE}
          alt="Motorcycle at Snow Creek Saloon"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/40 to-[#050505]" />
        
        {/* Logo */}
        <div className="absolute top-4 left-0 right-0 flex justify-center safe-top">
          <img src={LOGO_URL} alt="Rides and Dives" className="w-2/5 max-w-[140px] h-auto" />
        </div>
        
        {/* Hero Text */}
        <div className="absolute bottom-4 left-4 right-4">
          <h1 className="font-oswald text-3xl font-bold uppercase leading-tight">
            Plan Your <span className="text-bronze">Adventure</span>
          </h1>
          <p className="text-gray-400 mt-1 text-sm">
            Map rides from dive bar to dive bar. Hit the road.
          </p>
        </div>
      </div>

      {/* Bottom Section - Fixed */}
      <div className="flex-shrink-0 px-4 pt-4 pb-6 safe-bottom bg-[#050505]">
        {/* Feature Icons - Compact */}
        <div className="grid grid-cols-3 gap-2 mb-4">
          <div className="glass rounded-lg py-2 px-1 text-center">
            <Map className="w-5 h-5 mx-auto text-bronze mb-1" />
            <span className="text-[10px] text-gray-400 uppercase">Routes</span>
          </div>
          <div className="glass rounded-lg py-2 px-1 text-center">
            <Beer className="w-5 h-5 mx-auto text-cyan-400 mb-1" />
            <span className="text-[10px] text-gray-400 uppercase">Dives</span>
          </div>
          <div className="glass rounded-lg py-2 px-1 text-center">
            <Navigation className="w-5 h-5 mx-auto text-yellow-500 mb-1" />
            <span className="text-[10px] text-gray-400 uppercase">Navigate</span>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="space-y-2">
          <Button
            data-testid="get-started-btn"
            className="w-full h-12 bg-bronze hover:bg-bronze-600 text-white font-oswald text-base uppercase tracking-wider"
            onClick={() => navigate("/register")}
          >
            Start Planning
          </Button>
          <div className="flex gap-2">
            <Button
              data-testid="login-btn"
              variant="outline"
              className="flex-1 h-10 border-white/20 hover:bg-white/5 font-oswald uppercase tracking-wider text-sm"
              onClick={() => navigate("/login")}
            >
              Sign In
            </Button>
            <Button
              data-testid="discover-btn"
              variant="ghost"
              className="flex-1 h-10 text-gray-400 hover:text-white font-oswald uppercase tracking-wider text-sm"
              onClick={() => navigate("/discover")}
            >
              Explore
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;
